const actions = {
  CREATE_ACTIVITY_BEGIN: "CREATE_ACTIVITY_BEGIN",
  CREATE_ACTIVITY_SUCCESS: "CREATE_ACTIVITY_SUCCESS",
  CREATE_ACTIVITY_ERR: "CREATE_ACTIVITY_ERR",

  LIST_ACTIVITIES_BEGIN: "LIST_ACTIVITIES_BEGIN",
  LIST_ACTIVITIES_SUCCESS: "LIST_ACTIVITIES_SUCCESS",
  LIST_ACTIVITIES_ERR: "LIST_ACTIVITIES_ERR",

  UPDATE_ACTIVITY_BEGIN: "UPDATE_ACTIVITY_BEGIN",
  UPDATE_ACTIVITY_SUCCESS: "UPDATE_ACTIVITY_SUCCESS",
  UPDATE_ACTIVITY_ERR: "UPDATE_ACTIVITY_ERR",

  DELETE_ACTIVITY_BEGIN: "DELETE_ACTIVITY_BEGIN",
  DELETE_ACTIVITY_SUCCESS: "DELETE_ACTIVITY_SUCCESS",
  DELETE_ACTIVITY_ERR: "DELETE_ACTIVITY_ERR",

  BLOCK_ACTIVITY_BEGIN: "BLOCK_ACTIVITY_BEGIN",
  BLOCK_ACTIVITY_SUCCESS: "BLOCK_ACTIVITY_SUCCESS",
  BLOCK_ACTIVITY_ERR: "BLOCK_ACTIVITY_ERR",

  UNBLOCK_ACTIVITY_BEGIN: "UNBLOCK_ACTIVITY_BEGIN",
  UNBLOCK_ACTIVITY_SUCCESS: "UNBLOCK_ACTIVITY_SUCCESS",
  UNBLOCK_ACTIVITY_ERR: "UNBLOCK_ACTIVITY_ERR",

  GET_ACTIVITY_DETAILS_BEGIN: "GET_ACTIVITY_DETAILS_BEGIN",
  GET_ACTIVITY_DETAILS_SUCCESS: "GET_ACTIVITY_DETAILS_SUCCESS",
  GET_ACTIVITY_DETAILS_ERR: "GET_ACTIVITY_DETAILS_ERR",

  createActivityBegin: () => {
    return {
      type: actions.CREATE_ACTIVITY_BEGIN,
    };
  },

  createActivitySuccess: (data) => {
    return {
      type: actions.CREATE_ACTIVITY_SUCCESS,
      data,
    };
  },

  createActivityErr: (err) => {
    return {
      type: actions.CREATE_ACTIVITY_ERR,
      err,
    };
  },

  listActivitiesBegin: () => {
    return {
      type: actions.LIST_ACTIVITIES_BEGIN,
    };
  },

  listActivitiesSuccess: (data) => {
    return {
      type: actions.LIST_ACTIVITIES_SUCCESS,
      data,
    };
  },

  listActivitiesErr: (err) => {
    return {
      type: actions.LIST_ACTIVITIES_ERR,
      err,
    };
  },

  updateActivityBegin: () => {
    return {
      type: actions.UPDATE_ACTIVITY_BEGIN,
    };
  },

  updateActivitySuccess: (data) => {
    return {
      type: actions.UPDATE_ACTIVITY_SUCCESS,
      data,
    };
  },

  updateActivityErr: (err) => {
    return {
      type: actions.UPDATE_ACTIVITY_ERR,
      err,
    };
  },

  deleteActivityBegin: () => {
    return {
      type: actions.DELETE_ACTIVITY_BEGIN,
    };
  },

  deleteActivitySuccess: (data) => {
    return {
      type: actions.DELETE_ACTIVITY_SUCCESS,
      data,
    };
  },

  deleteActivityErr: (err) => {
    return {
      type: actions.DELETE_ACTIVITY_ERR,
      err,
    };
  },

  blockActivityBegin: () => {
    return {
      type: actions.BLOCK_ACTIVITY_BEGIN,
    };
  },

  blockActivitySuccess: (data) => {
    return {
      type: actions.BLOCK_ACTIVITY_SUCCESS,
      data,
    };
  },

  blockActivityErr: (err) => {
    return {
      type: actions.BLOCK_ACTIVITY_ERR,
      err,
    };
  },

  unblockActivityBegin: () => {
    return {
      type: actions.UNBLOCK_ACTIVITY_BEGIN,
    };
  },

  unblockActivitySuccess: (data) => {
    return {
      type: actions.UNBLOCK_ACTIVITY_SUCCESS,
      data,
    };
  },

  unblockActivityErr: (err) => {
    return {
      type: actions.UNBLOCK_ACTIVITY_ERR,
      err,
    };
  },

  getActivityDetailsBegin: () => {
    return {
      type: actions.GET_ACTIVITY_DETAILS_BEGIN,
    };
  },

  getActivityDetailsSuccess: (data) => {
    return {
      type: actions.GET_ACTIVITY_DETAILS_SUCCESS,
      data,
    };
  },

  getActivityDetailsErr: (err) => {
    return {
      type: actions.GET_ACTIVITY_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
